import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { EmptyStateComponent } from '@y42/core/empty-state';
import { GojsOverviewModule } from '../gojs-overview/gojs-overview.module';
import { GojsComponent } from './gojs.component';

@NgModule({
  imports: [CommonModule, GojsOverviewModule, LogoLoaderModule, EmptyStateComponent],
  declarations: [GojsComponent],
  exports: [GojsComponent],
})
export class GojsModule {}
